import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Mail, Lock, Loader2, ArrowLeft, Leaf } from 'lucide-react'
import './LoginPage.css'

function LoginPage({ onLogin }) {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState('')
    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        setError('')

        try {
            const response = await fetch('/api/auth/login.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email, password })
            })

            const data = await response.json()

            if (response.ok) {
                onLogin(data.user, data.token)
                navigate('/dashboard')
            } else {
                setError(data.error || 'Credenciales inválidas')
            }
        } catch (err) {
            setError('Error de conexión. Intente nuevamente.')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="login-page">
            <div className="login-bg">
                <div className="login-gradient"></div>
            </div>

            <div className="login-container">
                <button className="back-button" onClick={() => window.location.href = '/index.html'}>
                    <ArrowLeft size={20} />
                    <span>Volver</span>
                </button>

                <div className="login-card glass-card">
                    <div className="login-header">
                        <div className="login-logo">
                            <Leaf size={32} />
                        </div>
                        <h1>Bienvenido a TerraMind</h1>
                        <p>Ingresa tus credenciales para continuar</p>
                    </div>

                    <form onSubmit={handleSubmit} className="login-form">
                        <div className="form-group">
                            <label className="form-label">
                                <Mail size={16} />
                                Correo Electrónico
                            </label>
                            <input
                                type="email"
                                className="form-input"
                                placeholder="correo@empresa.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label">
                                <Lock size={16} />
                                Contraseña
                            </label>
                            <input
                                type="password"
                                className="form-input"
                                placeholder="Tu contraseña"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>

                        {error && (
                            <div className="form-error">
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            className="btn btn-primary btn-lg"
                            style={{ width: '100%' }}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <Loader2 size={20} className="animate-spin" />
                                    Ingresando...
                                </>
                            ) : (
                                'Iniciar Sesión'
                            )}
                        </button>
                    </form>

                    <div className="login-footer">
                        <p>¿No tienes cuenta? <a href="/index.html">Regístrate aquí</a></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoginPage
